export default "__VITE_ASSET__D1_G1vHJ__"